import { Form, Input, Modal, message, Radio } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { profileScreen } from '../../../../translates'
import { AppConfig } from '../../../../AppConfig'
import { useTaxSystemsQuery } from '../../../../api/react-query/dict'
import { useGetPartnerId } from '../../../../hooks/useGetPartnerId'

const layout = {
  wrapperCol: {
    xs: { span: 16 },
    sm: { span: 16 }
  },
  labelCol: {
    xs: { span: 8 },
    sm: { span: 8 }
  }
}

const otherTaxSystemName = 'otherTaxSystem'

const EditTaxData = ({
  visible = false,
  onCancel = () => {},
  loading = false,
  loadingPartnerData = false,
  loadingDocumentApproval = false,
  onChange,
  profile,
  backendFieldsErrors = {},
  onCommitDocument = () => {}
}) => {
  const id = useGetPartnerId()
  const [form] = Form.useForm()
  const [taxSystemsList, setTaxSystemsList] = useState([])
  const [taxSystem, setTaxSystem] = useState()
  const isSzContent = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szContent
  }, [profile?.personalData?.roleCode])

  const isResearcher = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.researcher
  }, [profile?.personalData?.roleCode])

  const isSzOperator = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szOperator
  }, [profile?.personalData?.roleCode])

  const isSzMentor = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szMentor
  }, [profile?.personalData?.roleCode])

  const {
    data: dataTaxSystems,
    isError: isErrorTaxSystems,
    // isSuccess: isSuccessTaxSystems,
    isLoading: isLoadingTaxSystems
  } = useTaxSystemsQuery({
    enabled: !(isSzContent || isResearcher || isSzOperator || isSzMentor)
  })
  const okButtonProps = useMemo(() => ({ className: 'green', loading }), [loading])
  const handleOnSave = async () => {
    form.submit()
    form.validateFields().then(fields => {
      const taxSystem = fields.taxSystem === otherTaxSystemName ? fields.otherTaxSystem : fields.taxSystem
      onChange({
        data: {
          firstName: profile.personalData.firstName,
          surname: profile.personalData.surname,
          middleName: profile.personalData.middleName,
          taxSystem
        },
        id
      })
    }).catch(() => {})
  }
  useEffect(() => {
    if (dataTaxSystems?.result) {
      setTaxSystemsList(dataTaxSystems?.result || [])
    }
  }, [dataTaxSystems?.result])

  useEffect(() => {
    if (!profile.personalData?.taxSystem || !dataTaxSystems?.result) return
    const taxIndex = dataTaxSystems.result.indexOf(profile.personalData.taxSystem)
    if (taxIndex !== -1) {
      form.setFieldsValue({ [profileScreen.input.taxSystem.name]: profile.personalData.taxSystem })
      return
    }
    form.setFieldsValue({ [profileScreen.input.taxSystem.name]: otherTaxSystemName })
    form.setFieldsValue({ [otherTaxSystemName]: profile.personalData.taxSystem })
  }, [profile.personalData?.taxSystem, dataTaxSystems?.result, form])

  useEffect(() => {
    if (!isErrorTaxSystems) return
    message.error('Не удалось получить список систем налогообложения.')
  }, [isErrorTaxSystems])
  return (
    <Modal
      width={700}
      visible
      title='Редактирование cистема налогообложения партнера'
      onCancel={onCancel}
      okText='Сохранить'
      cancelText='Отменить'
      okButtonProps={okButtonProps}
      onOk={handleOnSave}
      destroyOnClose
    >
      <div>
        <Form
          {...layout}
          name='editTax'
          form={form}
          scrollToFirstError
          isLoading={isLoadingTaxSystems || loadingPartnerData}
        >
          <Form.Item onChange={(event) => console.log('event', event)} name={[profileScreen.input.taxSystem.name]}>
            <Radio.Group
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                width: '100%'
              }}
              onChange={(event) => setTaxSystem(event.target.value)}
              options={[
                ...taxSystemsList.map((taxItem) => ({ value: taxItem, label: taxItem })),
                {
                  value: otherTaxSystemName,
                  label: (
                    <Form.Item
                      name={[otherTaxSystemName]}
                      rules={taxSystem === otherTaxSystemName ? [{ required: true, message: 'Пожалуйста, укажите систему налогообложения' }] : undefined}
                    >
                      <Input
                        variant='filled'
                        placeholder='ИП иная система налогообложения'
                        onSelect={() => {
                          form.setFieldsValue({ [profileScreen.input.taxSystem.name]: otherTaxSystemName })
                          setTaxSystem(otherTaxSystemName)
                        }}
                        style={{ width: 270 }}
                      />
                    </Form.Item>
                  )
                }
              ]}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}
export default EditTaxData
